import styled from 'styled-components'

export const PageHeader = styled.div`
    color: ${(p) => p.theme.colors.darkGrey};
    font-size: 24px;
    width: 100%;
    padding: 1em 10px 0.5em 10px;
    box-sizing: border-box;
`
